import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../service/common.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'output-modal-app',
  templateUrl: './a-output-modal.component.html',
  styleUrls: ['a-output-modal.component.css']
})

export class AOutputModalComponent {
  @Input() selected_person: any[];
  @Input() output_language_id: number;
  @Input() question_category: any[];
  @Input() t_event_id: any;
  @Input() view_title: any;

  select_tqc_id: any = null;

  constructor(
    public commonService: CommonService,
    public activeModal: NgbActiveModal,
  ) { }

  ngOnInit(): void {

    if (this.question_category.length > 0) {
      this.select_tqc_id = this.question_category[0]['t_question_category_id'];
    }

  };

  ret: any = {
    status: "",
    select_tqc_id: "",
    mode: "",
    person_list: [],
  }

  /**
   * 選択している受診者を除外する
   */
  delPerson(person) {
    this.selected_person = this.selected_person.filter(
      item => item.t_person_id != person.t_person_id
    );
  }

  modalCloseOK(mode) {
    this.commonService.modalOpens(53001,
      //ファイルを出力しますか？
      modalresult => {
        if (modalresult == "OK") {
          this.ret.status = modalresult;
          let person_list = this.selected_person.map(key => key['t_person_id']);
          this.ret.person_list = person_list;
          this.ret.mode = mode;

          this.ret.select_tqc_id = this.select_tqc_id;
          let select_cate = this.question_category.find(cate => cate['t_question_category_id'] === this.select_tqc_id);
          this.ret.class_id = select_cate['class_id'];
          this.ret.class_nm = select_cate['class_nm'];
          this.activeModal.close(this.ret);
        } else {
          return;
        }
      }
    );
  }
  modalCloseCancel() {
    this.ret.status = 'Cancel';
    this.activeModal.close(this.ret);
  }
}




// WEBPACK FOOTER //
// ./src/app/a0108-person/a-output-modal.component.ts